export default "__VITE_ASSET__f37672e3__"